/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type PublishDraftRequest,
    PublishDraftRequestFromJSON,
    PublishDraftRequestToJSON,
} from '../models/PublishDraftRequest';
import {
    type RollbackRequest,
    RollbackRequestFromJSON,
    RollbackRequestToJSON,
} from '../models/RollbackRequest';
import {
    type SaveDraftRequest,
    SaveDraftRequestFromJSON,
    SaveDraftRequestToJSON,
} from '../models/SaveDraftRequest';
import {
    type TemplateVersionResponse,
    TemplateVersionResponseFromJSON,
    TemplateVersionResponseToJSON,
} from '../models/TemplateVersionResponse';

export interface GetActiveVersionRequest {
    /**
     * Template identifier
     */
    templateId: string;
}

export interface GetVersionHistoryRequest {
    /**
     * Template identifier
     */
    templateId: string;
}

export interface PublishDraftOperationRequest {
    /**
     * Template identifier
     */
    templateId: string;
    /**
     * 
     */
    publishDraftRequest: PublishDraftRequest;
}

export interface RollbackOperationRequest {
    /**
     * Template identifier
     */
    templateId: string;
    /**
     * 
     */
    rollbackRequest: RollbackRequest;
}

export interface SaveDraftOperationRequest {
    /**
     * Template identifier
     */
    templateId: string;
    /**
     * 
     */
    saveDraftRequest: SaveDraftRequest;
}

/**
 * 
 */
export class TemplateVersionsApi extends runtime.BaseAPI {

    /**
     * Creates request options for getActiveVersion without sending the request
     */
    async getActiveVersionRequestOpts(requestParameters: GetActiveVersionRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling getActiveVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/templates/{templateId}/versions/active`;
        urlPath = urlPath.replace('{templateId}', encodeURIComponent(String(requestParameters['templateId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the currently active (latest PUBLISHED) version for the template, or 404 if the template has never been published.
     * Get active published version
     */
    async getActiveVersionRaw(requestParameters: GetActiveVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplateVersionResponse>> {
        const requestOptions = await this.getActiveVersionRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplateVersionResponseFromJSON(jsonValue));
    }

    /**
     * Returns the currently active (latest PUBLISHED) version for the template, or 404 if the template has never been published.
     * Get active published version
     */
    async getActiveVersion(requestParameters: GetActiveVersionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplateVersionResponse> {
        const response = await this.getActiveVersionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getVersionHistory without sending the request
     */
    async getVersionHistoryRequestOpts(requestParameters: GetVersionHistoryRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling getVersionHistory().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/templates/{templateId}/versions`;
        urlPath = urlPath.replace('{templateId}', encodeURIComponent(String(requestParameters['templateId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns all versions for a template ordered by versionNumber descending, showing status, publishedAt, publishedBy, and changelog.
     * List version history
     */
    async getVersionHistoryRaw(requestParameters: GetVersionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplateVersionResponse>> {
        const requestOptions = await this.getVersionHistoryRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplateVersionResponseFromJSON(jsonValue));
    }

    /**
     * Returns all versions for a template ordered by versionNumber descending, showing status, publishedAt, publishedBy, and changelog.
     * List version history
     */
    async getVersionHistory(requestParameters: GetVersionHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplateVersionResponse> {
        const response = await this.getVersionHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for publishDraft without sending the request
     */
    async publishDraftRequestOpts(requestParameters: PublishDraftOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling publishDraft().'
            );
        }

        if (requestParameters['publishDraftRequest'] == null) {
            throw new runtime.RequiredError(
                'publishDraftRequest',
                'Required parameter "publishDraftRequest" was null or undefined when calling publishDraft().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/templates/{templateId}/versions/publish`;
        urlPath = urlPath.replace('{templateId}', encodeURIComponent(String(requestParameters['templateId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PublishDraftRequestToJSON(requestParameters['publishDraftRequest']),
        };
    }

    /**
     * Publishes the current DRAFT version, making it the active version for form generation. Archives the previously active version if one exists. Requires a non-empty changelog in the request body.
     * Publish draft
     */
    async publishDraftRaw(requestParameters: PublishDraftOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplateVersionResponse>> {
        const requestOptions = await this.publishDraftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplateVersionResponseFromJSON(jsonValue));
    }

    /**
     * Publishes the current DRAFT version, making it the active version for form generation. Archives the previously active version if one exists. Requires a non-empty changelog in the request body.
     * Publish draft
     */
    async publishDraft(requestParameters: PublishDraftOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplateVersionResponse> {
        const response = await this.publishDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for rollback without sending the request
     */
    async rollbackRequestOpts(requestParameters: RollbackOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling rollback().'
            );
        }

        if (requestParameters['rollbackRequest'] == null) {
            throw new runtime.RequiredError(
                'rollbackRequest',
                'Required parameter "rollbackRequest" was null or undefined when calling rollback().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/templates/{templateId}/versions/rollback`;
        urlPath = urlPath.replace('{templateId}', encodeURIComponent(String(requestParameters['templateId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RollbackRequestToJSON(requestParameters['rollbackRequest']),
        };
    }

    /**
     * Creates a new DRAFT from an archived version\'s sections. Does NOT modify the source archived version. Requires that no DRAFT currently exists for the template.
     * Rollback from archived version
     */
    async rollbackRaw(requestParameters: RollbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplateVersionResponse>> {
        const requestOptions = await this.rollbackRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplateVersionResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new DRAFT from an archived version\'s sections. Does NOT modify the source archived version. Requires that no DRAFT currently exists for the template.
     * Rollback from archived version
     */
    async rollback(requestParameters: RollbackOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplateVersionResponse> {
        const response = await this.rollbackRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for saveDraft without sending the request
     */
    async saveDraftRequestOpts(requestParameters: SaveDraftOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['templateId'] == null) {
            throw new runtime.RequiredError(
                'templateId',
                'Required parameter "templateId" was null or undefined when calling saveDraft().'
            );
        }

        if (requestParameters['saveDraftRequest'] == null) {
            throw new runtime.RequiredError(
                'saveDraftRequest',
                'Required parameter "saveDraftRequest" was null or undefined when calling saveDraft().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/templates/{templateId}/versions/draft`;
        urlPath = urlPath.replace('{templateId}', encodeURIComponent(String(requestParameters['templateId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SaveDraftRequestToJSON(requestParameters['saveDraftRequest']),
        };
    }

    /**
     * Saves updated sections to the current DRAFT version with optimistic concurrency control. The request must include the updatedAt timestamp of the last-known state to detect concurrent modifications.
     * Save draft sections
     */
    async saveDraftRaw(requestParameters: SaveDraftOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TemplateVersionResponse>> {
        const requestOptions = await this.saveDraftRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TemplateVersionResponseFromJSON(jsonValue));
    }

    /**
     * Saves updated sections to the current DRAFT version with optimistic concurrency control. The request must include the updatedAt timestamp of the last-known state to detect concurrent modifications.
     * Save draft sections
     */
    async saveDraft(requestParameters: SaveDraftOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TemplateVersionResponse> {
        const response = await this.saveDraftRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
